import React, { useState, useContext } from 'react';
import PropTypes from 'prop-types';
import AttachableRepresentedEntity from './attach_entity/AttachableRepresentedEntity';
import AddNewButton from './attach_entity/AddNewButton';
import NewAttachedEntityForm from './attach_entity/NewAttachedEntityForm';
import UnspecifiedButton from './attach_entity/UnspecifiedButton';
import EntityTypeSelector from './attach_entity/EntityTypeSelector';
import { PitchWizardContext } from '../provider/pitch_wizard_provider';

function InitialAttachEntity({
 addNewEntityToPitch, addExistingEntityToPitch, onUnspecifiedButtonClick, sourceRequestType,
}) {
  const [entityType, setEntityType] = useState(null);
  const [showForm, setShowForm] = useState(false);

  const { promoEntities } = useContext(PitchWizardContext);

  const cancelAddNew = () => {
    setShowForm(false);
    setEntityType(null);
  };

  const welcome = sourceRequestType === 'welcome';

  return (
    <div>
      <h3>
        { !welcome ? (
          <> Who would you like to introduce? </>
        ) : (
          <> What would you like to submit in this pitch? </>
        )}
      </h3>
      {!showForm
        && promoEntities
        && promoEntities.map((entity) => (
          <AttachableRepresentedEntity
            key={`${entity.type}-${entity.id}`}
            entity={entity}
            onClickCallback={addExistingEntityToPitch}
          />
        ))}
      <AddNewButton onClick={() => setShowForm(true)} onCancel={() => cancelAddNew()} active={showForm} />
      {showForm && (
        <>
          <br />
          {!entityType && (
            <EntityTypeSelector
              onClick={() => setEntityType('Source')}
              entityType="Source"
              active={entityType === 'Source'}
              onCancel={() => setEntityType(null)}
            />
          )}
          {!entityType && (
            <EntityTypeSelector
              onClick={() => setEntityType('Product')}
              entityType="Product"
              active={entityType === 'Product'}
              onCancel={() => setEntityType(null)}
            />
          )}
        </>
      )}
      {showForm && entityType && (
        <div style={{ maxWidth: '800px' }}>
          <NewAttachedEntityForm
            addNewEntityToPitch={addNewEntityToPitch}
            onCancel={() => cancelAddNew()}
            type={entityType}
          />
        </div>
      )}
      {!showForm && <UnspecifiedButton onClick={() => onUnspecifiedButtonClick(false)} size="small" />}
    </div>
  );
}

InitialAttachEntity.propTypes = {
  addNewEntityToPitch: PropTypes.func.isRequired,
  addExistingEntityToPitch: PropTypes.func.isRequired,
  onUnspecifiedButtonClick: PropTypes.func.isRequired,
  sourceRequestType: PropTypes.string.isRequired,
};

export default InitialAttachEntity;
